<template>
    <PsychologicalSupport v-model:isModalActive="isModalActive"
                          :supportTexts="supportTexts"
                          :supportBtnText="supportBtnText"
    />
    <TasksDoes />
    <Investment />
    <Faq :faqBisnessContent="faqBisnessContent" />
    <Benefits :whyChooseUsBusiness="whyChooseUsBusiness" />
    <CallToAction v-model:isModalActive="isModalActive" />

    <teleport to="body">
      <Modal v-model="isModalActive">
        <template #header>
          <p>{{ t('meclee-ui.landings.business.modal.title') }}</p>
          <p class="text-sm">{{ t('meclee-ui.landings.business.modal.description') }}</p>
        </template>
        <template #content>
          <slot name="form" />
        </template>
      </Modal>
    </teleport>
</template>
<script setup lang="ts">
import Modal from "../../components/Modal.vue";
import PsychologicalSupport from "../../components/Business/SupportBlock.vue"
import TasksDoes from "../../components/Business/TasksDoes.vue"
import Investment from "../../components/Business/Investment.vue"
import Benefits from "../../components/Business/Benefits.vue"
import Faq from "../../components/Business/FaqBlock.vue"
import CallToAction from "../../components/Business/CallToAction.vue";

const { supportTexts, supportBtnText, whyChooseUsBusiness, modelValue } = defineProps({
    supportTexts: Array,
    supportBtnText: String,
    tasksDoesContent: Object,
    faqBisnessContent: Array,
    whyChooseUsBusiness: Array,
})

const { t } = useI18n();
const emit = defineEmits(['update:modelValue']);
defineExpose({
  closeForm
});

const isModalActive = ref(false);
function closeForm () {
  isModalActive.value = false;
}
</script>
